import { IBookingOnlineNewCustomer, IBookingOnlineOldCustomer } from 'pages/reservationBookingOnline/type';

export const types = {
  SET_FINISH_BOOKING: 'SET_FINISH_BOOKING' as const,
  SET_FORM_DATA_SUBMIT_BOOKING: 'SET_FORM_DATA_SUBMIT_BOOKING' as const,
};
export interface FinishBookingData{
  updateDate: string,
  updateUser: string,
  createDate: string,
  createUser: string,
  reservationId: string,
  responsibleStaffId: null | string,
  companyCode: string,
  customerBasicDataId:string,
  customerClass: string,
  desiredTime: string,
  reserveFrameId: string,
  contractCourseId: string,
  requests: string,
  mediaId: string | null,
  reserveStatus: string,
  cancelFlag: boolean,
  cancelType: number,
  staffName: string,
  desiredCourse:string,
  orgId:string,
  orgName:string,
  courseTime:string
  treatmentTime:number,
  courseCategoryId:string,
  customerNumber?: string,
  email?: string,
  birthDate?: string,
  contractCourseName?: string,

}

export interface IBookingOnlineOldCustomerExtend extends IBookingOnlineOldCustomer{
  customerFirstName: string,
  customerLastName: string,
}
export interface IFormDataSubmitData{
  companyCode: string;
  customerType: string;
  orgName: string;
  orgId: string;
  mediaCode: string;
  desiredCourse: string;
  courseTime: string;
  courseTimeSelect: string;
  courseDateSelect: string;
  treatmentTime: number;
  courseCategoryId: string;
  email:string;
  objectToPost: {
    newCustomer: IBookingOnlineNewCustomer,
    oldCustomer: IBookingOnlineOldCustomerExtend
  }
}


export const setReservationBooking = (data: FinishBookingData) => ({
  type: types.SET_FINISH_BOOKING,
  payload: data,
});

export const setFormDataSubmitBooking = (data: IFormDataSubmitData) => ({
  type: types.SET_FORM_DATA_SUBMIT_BOOKING,
  payload: data,
});

export type Actions = (
  | ReturnType<typeof setReservationBooking> | ReturnType<typeof setFormDataSubmitBooking>
);
